import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import GridList from '@material-ui/core/GridList';
import ListSubheader from '@material-ui/core/ListSubheader';
import GridListTile from '@material-ui/core/GridListTile';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import EnhancedGridHead from './EnhancedGridHead';
import { isSmartphone } from '../../../helpers';
import { cloneDeep } from 'lodash';
import Icon from '@projeccions-pdc/react-icon';

const styles = (theme) => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    gridList: {
        width: 'calc(100% - 10px)',
        marginTop: '5px!important',
        marginLeft: 'auto!important',
        marginRight: 'auto!important',
        marginBottom: '5px!important',
    },
    action: {
        display: 'inline-block',
        margin: '0px 5px',
    },
});

class EnhancedGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortBy: 'filename',
            reverse: false,
            selected: [],
            smartphoneView: undefined,
        };
    }

    componentDidMount() {
        isSmartphone((match) => this.handleSizeChange(match));
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    };

    static getDerivedStateFromProps(props, state) {
        let newSel = state.selected.map((a) => a);
        for (let i = 0; i < state.selected.length; i++) {
            let currSel = state.selected[i];

            let found = props.data.filter((element) => {
                return element[props.rowId] === currSel;
            });
            if (!found || found.length === 0) {
                let index = newSel.indexOf(currSel);
                if (index > -1) {
                    newSel.splice(index, 1);
                }
            }
        }
        return { selected: newSel };
    }

    handleSortChange = (evt) => {
        this.setState({ sortBy: evt.target.value });
    };

    handleReverseChange = () => {
        this.setState({ reverse: !this.state.reverse });
    };

    handleSelectAllClick = (event, checked) => {
        if (checked && this.props.multipleChoice !== false) {
            this.setState((state) => ({ selected: this.props.data.map((n) => n[this.props.rowId]) }));
            return;
        }
        this.setState({ selected: [] });
    };

    onResultSelected = (element, evt) => {
        evt.stopPropagation();
        let id = element[this.props.rowId];
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (this.props.multipleChoice !== false) {
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, id);
            } else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            } else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            } else if (selectedIndex > 0) {
                newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
            }
        } else {
            if (selectedIndex !== -1) {
                newSelected = [];
            } else {
                newSelected = [id];
            }
        }
        this.setState({ selected: newSelected });
    };

    isSelected = (id) => this.state.selected.indexOf(id) !== -1;

    handleAction = (onAction) => {
        if (onAction) {
            let selected = this.state.selected.map((elementId) => {
                return this.props.data.filter((element) => {
                    return element[this.props.rowId] === elementId;
                })[0];
            });
            onAction(selected);
        }
    };

    renderGrid = (sortedData, numSelected) => {
        let gridProps;
        if (this.props.gridProps) {
            gridProps = cloneDeep(this.props.gridProps);
        } else {
            gridProps = { cellHeight: 250, cols: 4, spacing: 10 };
        }

        if (this.state.smartphoneView === true) {
            gridProps.cols = Math.round(gridProps.cols / 2);
        }
        return (
            <GridList data-id="data-grid" className={this.props.classes.gridList} {...gridProps}>
                <GridListTile key="Subheader" cols={gridProps.cols} style={{ height: 'auto' }}>
                    {this.props.gridHeader !== false ? (
                        <EnhancedGridHead
                            gridTitle={this.props.gridTitle}
                            columnData={this.props.columnData}
                            actions={this.props.actions}
                            classes={this.props.classes}
                            numSelected={numSelected}
                            sortBy={this.state.sortBy}
                            handleSortChange={this.handleSortChange}
                            handleReverseChange={this.handleReverseChange}
                            handleAction={this.handleAction}
                            onSelectAllClick={this.handleSelectAllClick}
                            rowCount={this.props.data.length}
                        />
                    ) : (
                        ''
                    )}
                </GridListTile>
                {sortedData
                    ? sortedData.map((tile) => {
                          // return (
                          //     <GridItem
                          //         key={tile[this.props.rowId]}
                          //         resource={tile}
                          //         onResultSelected={this.onResultSelected}
                          //         columnData={this.props.columnData}
                          //         isSelected={this.isSelected(tile[this.props.rowId])}
                          //         onItemClick={this.props.onItemClick}
                          //     />
                          // );

                          return React.createElement(this.props.GridItemComponent, {
                              key: tile[this.props.rowId],
                              resource: tile,
                              onResultSelected: this.onResultSelected,
                              columnData: this.props.columnData,
                              isSelected: this.isSelected(tile[this.props.rowId]),
                              onItemClick: this.props.onItemClick,
                              embeded: this.props.embeded,
                          });
                      })
                    : ''}
                <GridListTile key="Footer" cols={gridProps.cols} style={{ height: 'auto' }}>
                    <ListSubheader component="div">
                        <div style={{ display: 'inline-block', textAlign: 'left', width: '20%' }}>
                            {this.props.loadMore ? (
                                <Button variant="outlined" onClick={this.props.loadMore} style={{ backgroundColor: '#fff' }}>
                                    {'Load more'}
                                </Button>
                            ) : (
                                ''
                            )}
                        </div>
                        <div style={{ display: 'inline-block', textAlign: 'right', width: '80%' }}>
                            {numSelected > 0
                                ? this.props.actions.map((action) => {
                                      return (
                                          <div key={action.action} className={this.props.classes.action}>
                                              <Button variant="outlined" onClick={() => this.handleAction(action.onAction)}>
                                                  {action.icon ? <Icon name={action.icon} size={'20px'} /> : ''}
                                                  {` ${action.action}`}
                                              </Button>
                                          </div>
                                      );
                                  })
                                : ''}
                        </div>
                    </ListSubheader>
                </GridListTile>
            </GridList>
        );
    };

    render() {
        // let GridItem = this.props.GridItemComponent;
        let sortId = this.state.sortBy;
        let sortedData = cloneDeep(this.props.data);
        sortedData = sortedData.sort((a, b) => {
            return a[sortId] < b[sortId] ? -1 : a[sortId] > b[sortId] ? 1 : 0;
        });
        if (this.state.reverse) {
            sortedData = sortedData.reverse();
        }
        let numSelected = this.state.selected.length;
        if (this.props.showContainer === false) {
            return this.renderGrid(sortedData, numSelected);
        }
        return (
            <Paper className={this.props.classes.root} elevation={2}>
                {this.renderGrid(sortedData, numSelected)}
            </Paper>
        );
    }
}
EnhancedGrid.propTypes = {
    multipleChoice: PropTypes.bool,
    gridTitle: PropTypes.string.isRequired,
    rowId: PropTypes.string.isRequired,
    columnData: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    loadMore: PropTypes.func,
    actions: PropTypes.array.isRequired,
    GridItemComponent: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.func]),
    classes: PropTypes.object.isRequired,
    onItemClick: PropTypes.func,
    showContainer: PropTypes.bool,
    gridHeader: PropTypes.bool,
    gridProps: PropTypes.object,
    embeded: PropTypes.bool,
};

export default withStyles(styles)(EnhancedGrid);
